export const GET_GROUPS_LOADING = 'GET_GROUPS_LOADING';
export const GET_GROUPS_COMPLETE = 'GET_GROUPS_COMPLETE';
export const GET_GROUPS_ERROR = 'GET_GROUPS_ERROR';
export const DELETE_GROUPS_LOADING = 'DELETE_GROUPS_LOADING';
export const DELETE_GROUPS_COMPLETE = 'DELETE_GROUPS_COMPLETE';
export const DELETE_GROUPS_ERROR = 'DELETE_GROUPS_ERROR';
export const TOGGLE_CONFIRM_DELETE = 'TOGGLE_CONFIRM_DELETE';
export const FILTER_GROUPS = 'FILTER_GROUPS';
export const SORT_GROUPS = 'SORT_GROUPS';
